import { handleActions } from 'redux-actions'
import {
  FETCH_CANDIDATES_DATA_INIT,
  FETCH_CANDIDATES_DATA_DONE,
  FETCH_CANDIDATES_DATA_FAIL,
  FETCH_CANDIDATE_ATTACHMENTS_INIT,
  FETCH_CANDIDATE_ATTACHMENTS_DONE,
  FETCH_CANDIDATE_ATTACHMENTS_FAIL,
} from '../actions/actions'
import $ from 'jquery'

const candidatesData = handleActions(
  {
    [FETCH_CANDIDATES_DATA_INIT]: (state, action) => {
      return {
        ...state,
        fetching: true,
        fetchedOnce: false,
      }
    },
    [FETCH_CANDIDATES_DATA_DONE]: (state, action) => {
      return {
        ...state,
        fetching: false,
        fetchedOnce: true,
        data: action.payload,
      }
    },
    [FETCH_CANDIDATES_DATA_FAIL]: (state, action) => {
      return {
        ...state,
        fetching: false,
        fetchedOnce: false,
      }
    },
    [FETCH_CANDIDATE_ATTACHMENTS_INIT]: (state, action) => {
      let nextState = $.extend(true, {}, state)
      const { candidateId, fileId, templateId } = action.payload
      if (candidateId) {
        let candidateIndex = nextState.data.findIndex(
          (item) => item.id === candidateId
        )
        if (candidateIndex > -1) {
          nextState.data[candidateIndex]['file_attachment_id'] = fileId
          nextState.data[candidateIndex]['template_id'] = templateId
          nextState.data[candidateIndex]['fileAttachments']['fetching'] = true
          nextState.fileAttachmentsFetchedFor = null
        }
      }
      return nextState
    },
    [FETCH_CANDIDATE_ATTACHMENTS_DONE]: (state, action) => {
      let nextState = $.extend(true, {}, state)
      const { candidateId, data, fileId, templateId } = action.payload
      if (candidateId) {
        let candidateIndex = nextState.data.findIndex(
          (item) => item.id === candidateId
        )
        if (candidateIndex > -1) {
          nextState.data[candidateIndex]['file_attachment_id'] = fileId
          nextState.data[candidateIndex]['template_id'] = templateId
          nextState.data[candidateIndex]['fileAttachments']['data'] = data
          nextState.data[candidateIndex]['fileAttachments']['fetching'] = false
          nextState.data[candidateIndex]['fileAttachments'][
            'fetchedOnce'
          ] = true
          nextState.fileAttachmentsFetchedFor = candidateId
        }
      }
      return nextState
    },
    [FETCH_CANDIDATE_ATTACHMENTS_FAIL]: (state, action) => {
      let nextState = $.extend(true, {}, state)
      const { candidateId, fileId, templateId } = action.payload
      if (candidateId) {
        let candidateIndex = nextState.data.findIndex(
          (item) => item.id === candidateId
        )
        if (candidateIndex > -1) {
          nextState.data[candidateIndex]['file_attachment_id'] = fileId
          nextState.data[candidateIndex]['template_id'] = templateId
          nextState.data[candidateIndex]['fileAttachments']['fetching'] = false
          nextState.data[candidateIndex]['fileAttachments'][
            'fetchedOnce'
          ] = false
          nextState.fileAttachmentsFetchedFor = false
        }
      }
      return nextState
    },
  },
  {
    fetching: false,
    fetchedOnce: false,
    fileAttachmentsFetchedFor: false,
    targetFileNames: {},
    data: null,
  }
)

export default candidatesData
